import stylesheet from './ContentBlock.scss?inline';

import CustomComponent from "../../base/customComponent/CustomComponent";

const VARIANTS = ['vertical', 'horizontal'];
const DEFAULT_VARIANT = 'vertical';

class NXTContentBlock extends CustomComponent {
    constructor() {
        super();
        this.customStyle = stylesheet;
    }

    get variant() {
        const value = this.getAttribute('variant');
        return value && VARIANTS.includes(value) ? value : DEFAULT_VARIANT;
    }

    get dividerTop(): boolean {
        return this.hasAttribute('divider-top');
    }

    get dividerBottom(): boolean {
        return this.hasAttribute('divider-bottom');
    }

    applyCtaLayout() {
        const buttonGroup = this.querySelector<HTMLElement>('nxt-button-group[slot="cta"]');
        const buttons = this.querySelectorAll<HTMLElement>('nxt-button');

        if (buttonGroup) {
            buttonGroup.setAttribute('variant', 'vertical');
            if (this.variant === 'vertical') {
                buttonGroup.setAttribute('variant-md', 'horizontal');
                buttonGroup.setAttribute('variant-lg', 'horizontal');
                buttonGroup.setAttribute('variant-xl', 'horizontal');
                buttonGroup.setAttribute('variant-xxl', 'horizontal');
            } else {
                buttonGroup.setAttribute('variant-md', 'vertical');
                buttonGroup.setAttribute('variant-lg', 'horizontal');
                buttonGroup.setAttribute('variant-xl', 'horizontal');
                buttonGroup.setAttribute('variant-xxl', 'horizontal');
            }
        }

        buttons.forEach(button => {
            button.setAttribute('block', '');
            button.setAttribute('size', 'lg');
            button.setAttribute('size-md', 'lg');
            button.setAttribute('size-lg', 'md');
            button.setAttribute('size-xl', 'md');
            button.setAttribute('size-xxl', 'md');
            if (this.variant === 'vertical') {
                button.setAttribute('md', 'grow');
                button.setAttribute('lg', 'grow');
                button.setAttribute('xl', 'grow');
                button.setAttribute('xxl', 'grow');
            } else {
                button.setAttribute('md', 'block');
                button.setAttribute('lg', 'grow');
                button.setAttribute('xl', 'grow');
                button.setAttribute('xxl', 'grow');
            }
        });
    }

    render() {
        this.applyCtaLayout();

        const container = document.createElement('div');
        container.classList.add(
            'content-block',
            `variant-${this.variant}`,
        );
        if (this.dividerTop) {
            container.classList.add('has-divider-top');
        }
        if (this.dividerBottom) {
            container.classList.add('has-divider-bottom');
        }
        container.innerHTML = `
            <div class="overline"><slot name="overline"></slot></div>
            <div class="title"><slot name="title"></slot></div>
            <div class="subtitle"><slot name="subtitle"></slot></div>
            <div class="copy"><slot name="copy"></slot></div>
            <div class="cta"><slot name="cta"></slot></div>
        `;
        this.setHasSlottedToParent(container);
        return container;
    }

}

customElements.define('nxt-content-block', NXTContentBlock);
